import { render, staticRenderFns } from "./ResourceChart.vue?vue&type=template&id=5ebd821d&"
import script from "./ResourceChart.vue?vue&type=script&lang=ts&"
export * from "./ResourceChart.vue?vue&type=script&lang=ts&"
import style0 from "./ResourceChart.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports